import { queryClient } from "@/App";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import useLogtoUser, { logtoUserQueryKey } from "@/hooks/api/useLogtoUser";
import useUpdateUser from "@/hooks/api/user/useUpdateUser";

const Onboarding = () => {
  const { mutate: updateUser } = useUpdateUser();
  const navigate = useNavigate();
  const { data: user, isLoading } = useLogtoUser();

  const handleUpdateUser = () => {
    updateUser(
      { first_name: "Timo", last_name: "Luick" },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: logtoUserQueryKey });
          navigate({ to: "/" });
        },
      },
    );
  };

  if (isLoading || !user) {
    return <div className="p-2">Loading...</div>;
  }

  if (user.custom_data?.intro_completed) {
    navigate({ to: "/" });
    return null;
  }

  return (
    <div className="bg-white p-2">
      Onboarding
      <button onClick={handleUpdateUser}>Update User</button>
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/onboarding")({
  component: Onboarding,
});
